import Vue from 'vue';
import Vuex from 'vuex';

import VuexORM from '@vuex-orm/core';

/* FETCHER ORM IMPORTS */
import FetcherFeed from './fetcher/admin/models/Feed';
import fetcherFeeds from './fetcher/admin/modules/feeds';
import FetcherFeedRule from './fetcher/admin/models/FeedRule';
import fetcherFeedRules from './fetcher/admin/modules/feedRules';
import FetcherJob from './fetcher/admin/models/Job';
import fetcherJobs from './fetcher/admin/modules/jobs';
import FetcherList from './fetcher/admin/models/List';
import fetcherLists from './fetcher/admin/modules/lists';
import FetcherNetwork from './fetcher/admin/models/Network';
import fetcherNetworks from './fetcher/admin/modules/networks';
import FetcherProfile from './fetcher/admin/models/Profile';
import fetcherProfiles from './fetcher/admin/modules/profiles';
import FetcherTag from './fetcher/admin/models/Tag';
import fetcherTags from './fetcher/admin/modules/tags';
import FetcherWikipediaPage from './fetcher/admin/models/WikipediaPage';
import fetcherWikipediaPages from './fetcher/admin/modules/wikipediaPages';

/* SPAWNER ORM IMPORTS */
import spawnerRepositories from './spawner/admin/modules/repositories';
import SpawnerRepository from './spawner/admin/models/Repository';
import spawnerDomainTlds from './spawner/admin/modules/domaintlds';
import SpawnerDomainTld from './spawner/admin/models/DomainTld';
import spawnerTemplates from './spawner/admin/modules/templates';
import SpawnerTemplate from './spawner/admin/models/Template';
import spawnerDomains from './spawner/admin/modules/domains';
import SpawnerDomain from './spawner/admin/models/Domain';
import spawnerDeployments from './spawner/admin/modules/deployments';
import SpawnerDeployment from './spawner/admin/models/Deployment';
import SpawnerServer from './spawner/admin/models/Server';
import spawnerServers from './spawner/admin/modules/servers';
import SpawnerSite from './spawner/admin/models/Site';
import spawnerSites from './spawner/admin/modules/sites';

/* CRAWLER ORM IMPORTS */
/* MONITOR ORM IMPORTS */

Vue.use(Vuex);

const database = new VuexORM.Database();

/* FETCHER ORM DB REGISTRATIONS */
database.register(FetcherFeed, fetcherFeeds);
database.register(FetcherFeedRule, fetcherFeedRules);
database.register(FetcherJob, fetcherJobs);
database.register(FetcherList, fetcherLists);
database.register(FetcherNetwork, fetcherNetworks);
database.register(FetcherProfile, fetcherProfiles);
database.register(FetcherTag, fetcherTags);
database.register(FetcherWikipediaPage, fetcherWikipediaPages);

/* SPAWNER ORM DB REGISTRATIONS */
database.register(SpawnerRepository, spawnerRepositories);
database.register(SpawnerDomainTld, spawnerDomainTlds);
database.register(SpawnerTemplate, spawnerTemplates);
database.register(SpawnerDomain, spawnerDomains);
database.register(SpawnerDeployment, spawnerDeployments);
database.register(SpawnerSite, spawnerSites);
database.register(SpawnerServer, spawnerServers);

/* CRAWLER ORM DB REGISTRATIONS */
/* MONITOR ORM DB REGISTRATIONS */

export default database;
